import type { MathRun } from '../../../Shared/Pdf/mathRuns.ts';

/** French place-value prompts (ADR 0051 part 3). See the English module for why each clause is written whole. */
export const placeClauses: string[] = [
    // Deliberately the short form ("est aux centaines"), not
    // "à la position des centaines". ADR 0051 §7 part 3's Language sweep
    // found the longer clauses ran Digit Value onto an extra page at 10 and
    // 12 per page - the clause is interpolated into every problem, so its
    // length is multiplied by the per-page count. Both forms are idiomatic.
    'aux unités',
    'aux dizaines',
    'aux centaines',
    'aux milliers',
    'aux dizaines de mille',
];

export const placeValuePrompts = {
    digitValue: (value: string, digit: number, placeClause: string) =>
        `Dans ${value}, le ${digit} est ${placeClause}. Sa valeur est`,
    // ADR 0130 §5. Every prompt is MathText runs, even one with no exponent, so
    // the two directions look alike on the page. The exponent is an ASCII "-"
    // (ADR 0070); French numbers group with a no-break space and mark decimals
    // with a comma (formatStandard).
    toScientific: (standard: string): MathRun[] => [{ text: `Écris ${standard} en notation scientifique.` }],
    toStandard: (coefficient: string, exponent: number): MathRun[] => [
        { text: `Écris ${coefficient} × 10` },
        { sup: String(exponent) },
        { text: ' en écriture décimale.' },
    ],
};
